<script lang="ts">
  import { ImageDecoration } from '../components';
  import HeroBlurb from './HeroBlurb.svelte';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ backgroundHeroImage } = properties);
</script>

<section
  class="pg-wrap"
  style="background:var(--vlt-lp-background);"
  id={properties?.anchor}
>
  <div class="main-section wf-section">
    <div class="main-container">
      <div class="blurb">
        <HeroBlurb {properties} {settings} fullWidth short />
        <div class="image-wrapper">
          <ImageDecoration image={backgroundHeroImage} />
        </div>
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  .blurb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--spacing-xlarge);
    width: 100%;
  }

  .main-section {
    display: flex;
    padding: 25px 27px;
    flex-direction: column;
    align-items: center;
    background-color: var(--background-color);
    color: var(--text-color, #0e0f11);
    font-family: var(--text-font, 'DM Sans');
  }

  .main-container {
    display: flex;
    width: 100%;
    max-width: 1300px;
    flex-direction: column;
    align-items: flex-start;
  }

  .image-wrapper {
    display: flex;
  }

  @media screen and (max-width: 991px) {
    .blurb {
      grid-row-gap: 20px;
      -ms-grid-columns: 1fr;
      grid-template-columns: 1fr;
    }
  }

  @media screen and (max-width: 767px) {
    .main-section {
      padding: 25px 15px;
    }

    .blurb {
      flex-direction: column-reverse;
    }

    .image-wrapper :global(svg) {
      width: 100%;
      height: unset;
      padding: 0 var(--spacing-small);
    }
  }
</style>
